import { FormattedMessage, useIntl } from 'react-intl';
import { SettingOutlined, MobileOutlined } from '@ant-design/icons';
import './Profile.less'
import { useEffect, useState } from 'react';
import ResetPassword from './components/ResetPasswordModal';
import { useAuth } from '../../hooks/auth/AuthContext';
import { format } from 'date-fns';
import ProfilePhoneModal from './components/ProfilePhoneModal';
import { useLazyQuery } from '@apollo/client';
import { PROFILE_COMM } from './Profile.gql';
import { client } from '../../apollo-clients';
import { Modal, Skeleton } from 'antd';
import DashboardWithdraw from '../withdraw/DashboardWithdraw';
import DashboardWithdrawRecord from '../withdraw/components/dashboard-withdraw-record/DashboardWithdrawRecord';
import moment from 'moment';

const Profile = () => {
    const intl = useIntl();
    const { authState } = useAuth();
    const [changePasswordModalVisible, setChangePasswordModalVisible] = useState(false);
    const [phoneModalVisible, setPhoneModalVisible] = useState(false);
    const [firstSendCode, setFirstSendCode] = useState(true);
    const [getProfileComm, { data, loading }] = useLazyQuery(PROFILE_COMM, { client, fetchPolicy: 'no-cache' });
    const [profileComm, setProfileComm] = useState<any>();
    const [withdrawModalVisible, setWithdrawModalVisible] = useState(false);
    const [withdrawHistoryModalVisible, setWithdrawHistoryModalVisible] = useState(false);

    useEffect(() => {
        getProfileComm();// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (data && data.profileComm) {
            setProfileComm(data.profileComm);
        }
    }, [data])

    return (
        <>
            <div className="profile-container">
                <div className='profile-item-container'>
                    <div className='profile-item-header-container'>
                        <div className='profile-item-title'><FormattedMessage id='PROFILE' /></div>
                        <div className='profile-item-header-right' onClick={() => { setChangePasswordModalVisible(true) }}><SettingOutlined /></div>
                    </div>
                    <div className='profile-item-content-container'>
                        <div className='profile-detail-container'>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='USERNAME' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.userName ?? '-'}</div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='ACCOUNT_STATUS' /></div>
                                <div className={`profile-detail-content ${authState?.userProfile?.isActive ? 'active' : 'suspended'}`}>
                                    <FormattedMessage id={authState?.userProfile?.isActive ? 'MEMBER_ACTIVE' : 'MEMBER_SUSPEND'} />
                                </div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='NAME' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.name ?? '-'}</div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='APPROVED_TIME' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.createdAt ? format(new Date(authState?.userProfile?.createdAt), "dd/MM/yyyy HH:mm:ss") : '-'}</div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='LAST_LOGIN' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.lastLogin ? format(new Date(authState?.userProfile?.lastLogin), "dd/MM/yyyy HH:mm:ss") : '-'}</div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='LAST_WITHDRAWAL' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.lastWithdrawal ? format(new Date(authState?.userProfile?.lastWithdrawal), "dd/MM/yyyy HH:mm:ss") : '-'}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='profile-item-container'>
                    <div className='profile-item-header-container'>
                        <div className='profile-item-title'><FormattedMessage id='CONTACT_INFO' /></div>
                        {/* <div className='profile-item-header-right'><SettingOutlined /></div> */}
                    </div>
                    <div className='profile-item-content-container'>
                        <div className='profile-detail-container'>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='PHONE' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.phone ?? '-'}</div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className={`status-icon-container`}>
                                    <div
                                        className={`status-icon ${authState?.userProfile?.phoneVerified ? 'verified' : 'unverified'}`}
                                        onClick={authState?.userProfile?.phoneVerified ? () => { } : () => { setPhoneModalVisible(true) }}
                                    ><MobileOutlined /></div>
                                </div>
                            </div>
                            <div className='profile-detail-item-container'>
                                <div className='profile-detail-title'><FormattedMessage id='EMAIL' /></div>
                                <div className='profile-detail-content'>{authState?.userProfile?.email ?? '-'}</div>
                            </div>
                            {/* <div className='profile-detail-item-container'>
                                <div className={`status-icon-container`}>
                                    <div className={`status-icon ${authState?.userProfile?.emailVerified ? 'verified' : 'unverified'}`}><MailOutlined /></div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className='profile-item-container'>
                    <div className='profile-item-header-container'>
                        <div className='profile-item-title'><FormattedMessage id='MENU_COMMISSION' /></div>
                        {/* <div className='profile-item-header-right'><SettingOutlined /></div> */}
                    </div>
                    <div className='profile-item-content-container'>
                        {loading ? <Skeleton /> :
                            <div className='profile-detail-container'>
                                <div className='profile-detail-item-container'>
                                    <div className='profile-detail-title'><FormattedMessage id='TRANSACTION_STATUS_PENDING' /></div>
                                    <div className='profile-detail-content'>{profileComm?.totalPendingCommission ?? '-'}</div>
                                </div>
                                <div className='profile-detail-item-container'>
                                    <div className='profile-detail-title'><FormattedMessage id='AVAILABLE' /></div>
                                    <div className='profile-detail-content'>{profileComm?.balance ?? '-'}</div>
                                </div>
                                <div className='profile-detail-item-container'>
                                    <div className='profile-detail-title'><FormattedMessage id='PROCESSING_WITHDRAWAL' /></div>
                                    <div className='profile-detail-content'>{profileComm?.totalPendingWithdrawal ?? '-'}</div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className='profile-footer-container'>
                        <div className='footer-btn' onClick={() => { setWithdrawHistoryModalVisible(true) }}><FormattedMessage id='VIEW' /></div>
                        <div className='footer-btn' onClick={() => { setWithdrawModalVisible(true) }}><FormattedMessage id='APPLY' /></div>
                        <div className='footer-btn' onClick={() => { getProfileComm() }}><FormattedMessage id='REFRESH' /></div>
                    </div>
                </div>
            </div>
            <ResetPassword visible={changePasswordModalVisible} setVisible={setChangePasswordModalVisible} />
            <ProfilePhoneModal modalVisible={{
                visible: phoneModalVisible,
                setVisible: setPhoneModalVisible
            }} firstSendCode={firstSendCode} setFirstSendCode={setFirstSendCode} phoneNumber={authState?.userProfile?.phone} mainPhoneNumber={authState?.userProfile?.phone ?? ''} isAddPhone={false} userPhonesRefetch={() => { }} />
            <Modal
                className="withdraw-form-modal"
                open={withdrawModalVisible}
                closable={true}
                footer={null}
                onCancel={() => { setWithdrawModalVisible(false) }}
                destroyOnClose
                title={intl.formatMessage({ id: 'WITHDRAWAL' })}
            >
                <DashboardWithdraw />
            </Modal>
            <Modal
                className="withdraw-form-modal"
                open={withdrawHistoryModalVisible}
                closable={true}
                footer={null}
                onCancel={() => { setWithdrawHistoryModalVisible(false) }}
                destroyOnClose
                title={intl.formatMessage({ id: 'WITHDRAWAL_RECORD' })}
            >
                <DashboardWithdrawRecord startDate={moment(moment(new Date()).toString()).startOf('month')}
                    endDate={moment(moment(new Date()).toString()).endOf('day')} pagination={false} isTrigger={true} />
            </Modal>
        </>
    )
}

export default Profile;